import React from "react";
import { Link } from "react-router-dom";
import _ from "lodash";
import "./index.scss";
import {ReactComponent as SVGArrowUp} from '../../assets/arrow-up.svg';

const Breadcrumb = (props) => {
    return (
        <div className="breadcrumb-wrapper">
            <ul className="breadcrumb">
                {
                    props.items.map(item => (
                        <li key={item[0]}>
                            {
                                item.length == 2 && 
                                <Link to={item[0]} >{item[1]}</Link>
                            }
                            {
                                item.length == 1 &&
                                <span>{item[0]}</span>
                            }
                            <SVGArrowUp/>
                            
                        </li>
                    ))
                }
            </ul>
        </div>
    )
}

export default Breadcrumb;